import * as React from "react";
import Input from "../../Input-new/Input";
import Checkbox from "../../CheckboxNew";
import Dropdown from "../../Dropdown/Dropdown";
import UploadFiles from "./UploadFiles";

const items=[{
    label:'Contract',
    name:'in_neg_file_1'
    },{
    label:'Additional File 1',
    name:'in_neg_file_2'
    },{
    label:'Additional File 2',
    name:'in_neg_file_3'
    },{
    label:'Additional File 3',
    name:'in_neg_file_4'
    },{
    label:'Additional File 4',
    name:'in_neg_file_5'
    }];

const InNegotiationUnderContract = ({isAgent, data, handleChangeInput, handleChangeDropdown, handleChangeFile, redirectToEscrowTracking, viewMode, deleted}) => {
    
    return (
        <div className="In-negotiation">
            <div className="In-negotiation_actions">
                {
                    data.status === 'Under Contract' &&
                    <button type='button'
                            className='button-new positive'
                            onClick={redirectToEscrowTracking}>
                        Escrow Tracking
                    </button>
                }
                <Checkbox
                    text='AthCap Financing'
                    type={viewMode ? 'uncheckable' : 'checkable'}
                    isSelected={data.hsc_financing}
                    handleClick={handleChangeInput}
                    name='hsc_financing'
                />
                <Checkbox
                    text='Other Financing'
                    type={viewMode ? 'uncheckable' : 'checkable'}
                    isSelected={data.other_financing}
                    handleClick={handleChangeInput}
                    name='other_financing'
                />
            </div>

            <div className="In-negotiation_column">
                <Input
                    className="In-negotiation_column_item"
                    type="text"
                    valueType="integer"
                    name="negotiation_price"
                    label="Price"
                    value={data.negotiation_price}
                    disabled={isAgent}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isDollar
                />
                <Input
                    className="In-negotiation_column_item"
                    type="text"
                    valueType="percent"
                    name="negotiation_cap_rate"
                    label="Cap Rate - auto"
                    value={data.negotiation_cap_rate}
                    disabled
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="In-negotiation_column_item"
                    type="text"
                    valueType="float"
                    name="potential_fee"
                    label="STRIVE Fee - Auto"
                    value={data.potential_fee}
                    disabled
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    decimals={2}
                    isDollar
                />
                <Input
                    className="In-negotiation_column_item"
                    type="text"
                    valueType="float"
                    name="negotiation_price_per_sqft"
                    label="PSF – auto"
                    value={data.negotiation_price_per_sqft}
                    disabled
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    decimals={2}
                    isDollar
                />
            </div>
            <div className="In-negotiation_column">
            {
                data.hsc_financing &&
                <Dropdown
                    className="In-negotiation_column_item"
                    data={data}
                    isFromProperty
                    optionsType='status-financing'
                    value={data.hsc_status}
                    valueKey="hsc_status"
                    label='AthCap Status'
                    disabled={isAgent}
                    handleParentChange={handleChangeDropdown}
                    viewMode={viewMode}
                    deleted={deleted}
                />
            }
            <UploadFiles 
                classNames="In-negotiation_column_item"
                data={data}
                viewMode={viewMode} 
                deleted={deleted}
                handleChangeFile={handleChangeFile}
                maxFilesAmount={items.length}
                items={items}
                disabled={isAgent}/>
            </div>
        </div>
    );
};

export default InNegotiationUnderContract;
